module.exports = __webpack_public_path__ + "static/media/truelab.64d687f7.jpeg";